import { render, staticRenderFns } from "./CardAbout.vue?vue&type=template&id=314a5501"
import script from "./CardAbout.vue?vue&type=script&lang=js"
export * from "./CardAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports